import { IInitialState } from 'us.collection.routines-and-activities/reducers/History/Interfaces';
import dayjs from 'dayjs';

export const initialState: IInitialState = {
	note: {
		data: [],
		isLoading: false,
	},
	creditorPortalNote: {
		data: [],
		isLoading: false,
	},
	debtorPortalNote: {
		data: [],
		isLoading: false,
	},
	workflowHistory: [],
	activity: {
		data: [],
		isLoading: false,
	},
	summaryData: {
		data: [],
		isLoading: false,
	},
	filterValue: 'all',
	searchValue: {},
	attachement: {
		data: [],
		isLoading: false,
		content: '',
	},
	parameters: {
		data: {},
		isLoading: false,
	},
	initailValue: {
		runBy: false,
		runNow: true,
		executingDateTime: dayjs(),
	},
	activities: {
		data: [],
		isLoading: false,
	},
	activiesFilterValue: 'all',
	userAndCase: {
		user: '',
		caseNumber: '',
	},
	noteDrawer: {
		title: '',
		visible: false,
	},
	runActivityDrawer: {
		title: '',
		visible: false,
	},
	runActivityStatus: false,
	isNoteSaving: false
};
